import guid from "guid";
import { convertFirstChar } from "./generic.methods";
import { Enums } from "./dropdown-enums";

/**
 * @name @structureAndCleanupData
 * @description map data as per server's contract and remove undefined props
 * @params formData => form data, schema => nestied objects schema
 * */
export const structureAndCleanupData = (
  options,
  schema,
  nestedKey,
  socialMedias
) => {
  let mappedData = cleanupUndefined({ ...options.data });
  for (const [key, value] of Object.entries(schema)) {
    socialMedias.forEach((media) => {
      const fieldName = media.name;
      if (options?.savedLead)
        mappedData[fieldName] = options.data?.[fieldName] ?? "";
    });
    mappedData[key] = {};
    value.forEach((item) => {
      let actualKey = "",
        replaceKey = "";
      if (Array.isArray(item)) {
        actualKey = item[0];
        replaceKey = item[1];
      } else {
        actualKey = item;
      }
      if (mappedData?.[actualKey]) {
        if (item === "phone") {
          mappedData[key][item] = cleanedPhoneNumber(mappedData?.[item]);
          // mappedData["countryCode"] + cleanedPhoneNumber(mappedData?.[item]);
        } else if (item === "tags") {
          mapTagsData(mappedData, key, item, options?.savedLead);
        } else {
          console.log(key, item, mappedData);
          mappedData[key][replaceKey || actualKey] = mappedData?.[actualKey];
        }

        delete mappedData[item];
      }
    });
    // }
  }

  if (options.data?.includes?.length) {
    for (const key in mappedData) {
      if (!options?.includes?.includes(key)) {
        delete obj[key];
      }
    }
  }
  mappedData = { [nestedKey]: { ...mappedData }, requestId: guid.raw() };
  return mappedData;
};

/**
 * @name @structureDirty
 * @description add guid and remove undefined or null
 * @params formData => form data, nestedKey => object name
 * */
export const structureDirty = (formData, nestedKey) => {
  let mappedData = cleanupUndefined({ ...formData });
  mappedData = { [nestedKey]: { ...mappedData }, requestId: guid.raw() };

  return mappedData;
};

/**
 * @name @cleanupUndefined
 * @params formData => form data
 * @description remove undefined props
 * */
export const cleanupUndefined = (formData) => {
  const cleanedData = {};
  for (let prop in formData) {
    if (formData[prop] !== undefined && formData[prop] !== null) {
      cleanedData[prop] = formData[prop];
    }
    if (formData.hasOwnProperty(prop) && formData[prop] === "") {
      delete cleanedData[prop];
    }
  }
  return cleanedData;
};
/**
 * @name @mapCustomFieldsToLead
 * @params data => lead data, customFields => custom fields data
 * @description convert custom fields key first char to small case
 * */
export const mapCustomFieldsToLead = (data, customFields) => {
  let lead = { ...data };
  const leadCustomFieldData = {};
  if (customFields) {
    customFields.forEach((cField) => {
      if (cField.fieldType == Enums.CustomFieldType.MultiValue) {
        const fieldVal = lead.leadCustomMultipleValues.filter(
          (field) => field.customFieldId === cField.id
        )?.[0];
        lead[cField?.mappedName] = fieldVal?.selectedIds;
      }
      const fieldValueKey = convertFirstChar(cField?.name);
      if (lead[fieldValueKey]) {
        leadCustomFieldData[cField.name] = lead[fieldValueKey];
      }
      delete lead[fieldValueKey];
    });
  }
  if (lead.leadCustomMultipleValues) {
    delete lead.leadCustomMultipleValues;
  }

  return { ...lead, ...leadCustomFieldData };
};

/**
 * @name @destructureData
 * @params data => api response data, schema to desctruture, similar to @structureAndCleanupData
 * @description lean formdata
 * */
export const destructureData = (data, schema) => {
  const mappedData = { ...data };

  for (const [key, value] of Object.entries(schema)) {
    value.forEach((item) => {
      mappedData[item] = mappedData?.[key]?.[item];
      delete mappedData[key];
    });
  }
  return mappedData;
};

export const convertKeysToCamelCase = (data) => {
  if (Array.isArray(data)) {
    return data.map(convertKeysToCamelCase);
  } else if (typeof data === "object" && data !== null) {
    return Object.keys(data).reduce((result, key) => {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      result[newKey] = convertKeysToCamelCase(data[key]);
      return result;
    }, {});
  }
  return data;
};

// removed special characters and spaces from phone number, only start + will remain
export const cleanedPhoneNumber = (phone = "") =>
  phone.replace(/[^\d+]|^[^\d+]|(\+).*\+/g, "");

// create tags data on submit as per BE requirement
const mapTagsData = (mappedData, key, item, savedLead) => {
  let tagIds = mappedData[item]?.map((tag) => tag.id) || [];
  let oldTagIds = savedLead?.leadTags?.map((item) => item.tagId) || [];
  mappedData[key] = {
    isUpdateEnabled: !!savedLead,
    leadTagsAdded: tagIds,
    leadTagsRemoved: oldTagIds.length
      ? filterOutRemovedTags(tagIds, oldTagIds)
      : [],
  };
};

const filterOutRemovedTags = (newTags, oldTags) => {
  return oldTags.filter((tag) => !newTags.includes(tag));
};
